import { html } from 'lit';
import componentStyles from './legal.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Legal extends OutlineElement {
  static styles = [super.styles, componentStyles];

  render() {
    return html`
      <span class="legal">
        <slot></slot>
      </span>
    `;
  }
}

customElements.define('hf-legal', Legal);
